import { areThereProductOfferingTypesIntoOfferArray } from '../../utils/general';

/**
 * Función que normaliza la crea de custo que nos trae la información para pintar un texto
 * bajo el carrito (potencialmente para cambio de precio)
 * @param {string} flowName name del flujo actual
 * @param {object} purchasePriceCartInfo Objeto con la info completa para todos los flujos
 * @returns Objeto que contendrá el texto a pintar, así como el texto para el enlace de condiciones legales
 */
export const normalizePurchasePriceInfo = (
  flowName,
  purchasePriceCartInfo,
  productOfferingTypes,
  hasPromotionApplied,
) => {
  if (
    purchasePriceCartInfo
    && purchasePriceCartInfo.buyProcess
    && purchasePriceCartInfo.buyProcess[flowName]
  ) {
    const purchaseCartInfo = purchasePriceCartInfo.buyProcess[flowName];

    if (
      purchaseCartInfo
      && purchaseCartInfo.flagPriceChanges
      && Array.isArray(productOfferingTypes)
      && Array.isArray(purchaseCartInfo.productOfferingTypes)
      && areThereProductOfferingTypesIntoOfferArray(
        productOfferingTypes,
        purchaseCartInfo.productOfferingTypes,
      )
      && purchaseCartInfo.data
    ) {
      const {
        cartText, hasPromotionText, linkItem, hidePrices,
      } = purchaseCartInfo.data;

      return {
        cartText: hasPromotionApplied ? hasPromotionText : cartText,
        linkItem,
        hidePrices,
      };
    }
  }

  return null;
};
